import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import imageProxy from '@/js/common/Domain/Service/imageProxy';
import template from './template.html';

@extendDecorator({
    collection: new Backbone.Collection(),
    computeds: {
        roomCategoryPhotos: {
            deps: ['room'],
            get(room) {
                return room.photos || [];
            },
        },
    },
})
export default class RoomCategoryPhotos extends Backbone.Epoxy.View {
    initialize() {
        this.applyBindings();
        this.render();
    }

    render() {
        const roomDescriptionPhotos = this.getBinding('roomCategoryPhotos');
        if (roomDescriptionPhotos?.length) {
            this.$el.html(template({
                photos: roomDescriptionPhotos,
                imageProxy,
            }));
        } else {
            this.$el.empty();
        }
    }
}